<nav class="bg-white shadow-lg border-b border-gray-100 sticky top-0 z-[9999]" *ngIf="isAuthenticated">
  <div class="w-full px-4 sm:px-6 lg:px-8">
    <div class="flex justify-between items-center h-16">
      <!-- Logo and Navigation - Left Side -->
      <div class="flex items-center">
        <!-- Logo pour tous les écrans avec lien vers la page d'accueil -->
        <a routerLink="/home" class="flex items-center mr-4 2xl:mr-8 cursor-pointer">
          <!-- Icône avec dégradé de couleur -->
          <div class="bg-gradient-to-r from-blue-600 via-purple-600 to-blue-800 bg-clip-text text-transparent">
            <i class="fa fa-cubes text-2xl 2xl:text-3xl"></i>
          </div>

          <!-- Texte uniquement sur très grands écrans (2xl et plus) -->
          <!-- Utilisation de @media query pour s'assurer que cela fonctionne sur les écrans > 1600px -->
          <style>
            @media (min-width: 1600px) {
              .logo-text {
                display: block !important;
              }
            }
          </style>
          <div class="hidden logo-text ml-3" style="display: none;">
            <div class="flex flex-col">
              <div
                class="text-lg font-bold bg-gradient-to-r from-blue-600 via-purple-600 to-blue-800 bg-clip-text text-transparent">
                Gestion Stock
              </div>
              <div class="text-xs text-gray-500">
                Management System
              </div>
            </div>
          </div>
        </a>

        <!-- Desktop Navigation avec breakpoint personnalisé -->
        <style>
          @media (max-width: 1399px) {
            .nav-buttons-1400 {
              display: none !important;
            }
          }

          @media (min-width: 1400px) {
            .nav-buttons-1400 {
              display: flex !important;
            }
          }
        </style>
        <div class="nav-buttons-1400 items-center space-x-1">
          <!-- Home Link -->
          <a routerLink="/home" routerLinkActive="text-blue-600 bg-blue-50"
            class="flex items-center px-4 py-2 text-sm font-medium text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-200">
            <i class="fa fa-home w-4 h-4 mr-2"></i>
            Accueil
          </a>

          <!-- Products Dropdown -->
          <div class="relative">
            <button (click)="toggleDropdown('products')"
              class="flex items-center px-4 py-2 text-sm font-medium text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-200">
              <i class="fa fa-box w-4 h-4 mr-2"></i>
              Produits
              <i class="fa fa-chevron-down w-4 h-4 ml-1 transition-transform duration-200"
                [class.rotate-180]="activeDropdown === 'products'"></i>
            </button>
            <div *ngIf="activeDropdown === 'products'"
              class="absolute top-full left-0 mt-2 w-64 bg-white rounded-xl shadow-xl border border-gray-100 py-2 z-[9999]">
              <a routerLink="/addProduct" (click)="closeDropdown()"
                class="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-emerald-50 group transition-all duration-200">
                <div class="w-8 h-8 rounded-lg bg-emerald-100 flex items-center justify-center mr-3 group-hover:bg-emerald-200 transition-colors">
                  <i class="fa fa-plus text-emerald-600"></i>
                </div>
                <div class="flex flex-col">
                  <span class="font-bold whitespace-nowrap group-hover:text-emerald-700">Ajouter un produit</span>
                  <span class="text-[10px] text-gray-400 leading-none">Nouvel article stock</span>
                </div>
              </a>
              <a routerLink="/productList" (click)="closeDropdown()"
                class="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-indigo-50 group transition-all duration-200">
                <div class="w-8 h-8 rounded-lg bg-indigo-100 flex items-center justify-center mr-3 group-hover:bg-indigo-200 transition-colors">
                  <i class="fa fa-list text-indigo-600"></i>
                </div>
                <div class="flex flex-col">
                  <span class="font-bold whitespace-nowrap group-hover:text-indigo-700">Liste des produits</span>
                  <span class="text-[10px] text-gray-400 leading-none">Inventaire complet</span>
                </div>
              </a>
            </div>
          </div>

          <!-- Orders Dropdown -->
          <div class="relative">
            <button (click)="toggleDropdown('orders')"
              class="flex items-center px-4 py-2 text-sm font-medium text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-200">
              <i class="fa fa-shopping-cart w-4 h-4 mr-2"></i>
              Commandes
              <i class="fa fa-chevron-down w-4 h-4 ml-1 transition-transform duration-200"
                [class.rotate-180]="activeDropdown === 'orders'"></i>
            </button>
            <div *ngIf="activeDropdown === 'orders'"
              class="absolute top-full left-0 mt-2 w-64 bg-white rounded-xl shadow-xl border border-gray-100 py-2 z-[9999]">
              <button (click)="openClientFormDialog('addOrder'); closeDropdown()"
                class="w-full flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 group transition-all duration-200">
                <div class="w-8 h-8 rounded-lg bg-blue-100 flex items-center justify-center mr-3 group-hover:bg-blue-200 transition-colors">
                  <i class="fa fa-file-invoice text-blue-600"></i>
                </div>
                <div class="flex flex-col text-left">
                  <span class="font-bold whitespace-nowrap group-hover:text-blue-700">Créer une commande</span>
                  <span class="text-[10px] text-gray-400 leading-none">Nouvelle facture</span>
                </div>
              </button>
              <button (click)="openSmartRefundFinder(); closeDropdown()"
                class="w-full flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-rose-50 group transition-all duration-200">
                <div class="w-8 h-8 rounded-lg bg-rose-100 flex items-center justify-center mr-3 group-hover:bg-rose-200 transition-colors">
                  <i class="fa fa-reply text-rose-600"></i>
                </div>
                <div class="flex flex-col text-left">
                  <span class="font-bold whitespace-nowrap group-hover:text-rose-700">Créer un retour</span>
                  <span class="text-[10px] text-gray-400 leading-none">Remboursement partiel/total</span>
                </div>
              </button>
              <a routerLink="/orderList" (click)="closeDropdown()"
                class="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-purple-50 group transition-all duration-200">
                <div class="w-8 h-8 rounded-lg bg-purple-100 flex items-center justify-center mr-3 group-hover:bg-purple-200 transition-colors">
                  <i class="fa fa-list-alt text-purple-600"></i>
                </div>
                <div class="flex flex-col">
                  <span class="font-bold whitespace-nowrap group-hover:text-purple-700">Liste des commandes</span>
                  <span class="text-[10px] text-gray-400 leading-none">Historique des ventes</span>
                </div>
              </a>
              <a routerLink="/avoir-list" (click)="closeDropdown()"
                class="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-orange-50 group transition-all duration-200">
                <div class="w-8 h-8 rounded-lg bg-orange-100 flex items-center justify-center mr-3 group-hover:bg-orange-200 transition-colors">
                  <i class="fa fa-undo text-orange-600"></i>
                </div>
                <div class="flex flex-col">
                  <span class="font-bold whitespace-nowrap group-hover:text-orange-700">Liste des avoirs</span>
                  <span class="text-[10px] text-gray-400 leading-none">Historique des retours</span>
                </div>
              </a>
            </div>
          </div>

          <!-- Loans Dropdown -->
          <div class="relative">
            <button (click)="toggleDropdown('loans')"
              class="flex items-center px-4 py-2 text-sm font-medium text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-200">
              <i class="fa fa-credit-card w-4 h-4 mr-2"></i>
              Prêts
              <i class="fa fa-chevron-down w-4 h-4 ml-1 transition-transform duration-200"
                [class.rotate-180]="activeDropdown === 'loans'"></i>
            </button>
            <div *ngIf="activeDropdown === 'loans'"
              class="absolute top-full left-0 mt-2 w-64 bg-white rounded-xl shadow-xl border border-gray-100 py-2 z-[9999]">
              <button (click)="openClientFormDialog('addCashLoan'); closeDropdown()"
                class="w-full flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-cyan-50 group transition-all duration-200">
                <div class="w-8 h-8 rounded-lg bg-cyan-100 flex items-center justify-center mr-3 group-hover:bg-cyan-200 transition-colors">
                  <i class="fa fa-plus text-cyan-600"></i>
                </div>
                <div class="flex flex-col text-left">
                  <span class="font-bold whitespace-nowrap group-hover:text-cyan-700">Ajouter un prêt</span>
                  <span class="text-[10px] text-gray-400 leading-none">Nouveau crédit client</span>
                </div>
              </button>
              <a routerLink="/loanList" (click)="closeDropdown()"
                class="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-teal-50 group transition-all duration-200">
                <div class="w-8 h-8 rounded-lg bg-teal-100 flex items-center justify-center mr-3 group-hover:bg-teal-200 transition-colors">
                  <i class="fa fa-list text-teal-600"></i>
                </div>
                <div class="flex flex-col text-left">
                  <span class="font-bold whitespace-nowrap group-hover:text-teal-700">Liste des prêts</span>
                  <span class="text-[10px] text-gray-400 leading-none">Suivi des paiements</span>
                </div>
              </a>
            </div>
          </div>

          <!-- Clients Menu -->
          <div class="relative">
            <button (click)="toggleDropdown('clients')"
              class="flex items-center px-4 py-2 text-sm font-medium text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-200">
              <i class="fa fa-users w-4 h-4 mr-2"></i>
              Clients
              <i class="fa fa-chevron-down w-4 h-4 ml-1 transition-transform duration-200"
                [class.rotate-180]="activeDropdown === 'clients'"></i>
            </button>
            <div *ngIf="activeDropdown === 'clients'"
              class="absolute top-full left-0 mt-2 w-64 bg-white rounded-xl shadow-xl border border-gray-100 py-2 z-[9999]">
              <a routerLink="/addClient" (click)="closeDropdown()"
                class="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-amber-50 group transition-all duration-200">
                <div class="w-8 h-8 rounded-lg bg-amber-100 flex items-center justify-center mr-3 group-hover:bg-amber-200 transition-colors">
                  <i class="fa fa-user-plus text-amber-600"></i>
                </div>
                <div class="flex flex-col text-left">
                  <span class="font-bold whitespace-nowrap group-hover:text-amber-700">Ajouter un client</span>
                  <span class="text-[10px] text-gray-400 leading-none">Nouveau profil client</span>
                </div>
              </a>
            </div>
          </div>

          <!-- Discrepancies Menu -->
          <div class="relative">
            <button (click)="toggleDropdown('discrepancies')"
              class="flex items-center px-4 py-2 text-sm font-medium text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-200">
              <i class="fa fa-exclamation-triangle w-4 h-4 mr-2"></i>
              Écarts
              <i class="fa fa-chevron-down w-4 h-4 ml-1 transition-transform duration-200"
                [class.rotate-180]="activeDropdown === 'discrepancies'"></i>
            </button>
            <div *ngIf="activeDropdown === 'discrepancies'"
              class="absolute top-full left-0 mt-2 w-64 bg-white rounded-xl shadow-xl border border-gray-100 py-2 z-[9999]">
              <a routerLink="/cash-discrepancies" (click)="closeDropdown()"
                class="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-red-50 group transition-all duration-200">
                <div class="w-8 h-8 rounded-lg bg-red-100 flex items-center justify-center mr-3 group-hover:bg-red-200 transition-colors">
                  <i class="fa fa-money-bill text-red-600"></i>
                </div>
                <div class="flex flex-col text-left">
                  <span class="font-bold whitespace-nowrap group-hover:text-red-700">Écarts de Caisse</span>
                  <span class="text-[10px] text-gray-400 leading-none">Rapprochement financier</span>
                </div>
              </a>
              <a routerLink="/stock-discrepancies" (click)="closeDropdown()"
                class="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-amber-50 group transition-all duration-200">
                <div class="w-8 h-8 rounded-lg bg-amber-100 flex items-center justify-center mr-3 group-hover:bg-amber-200 transition-colors">
                  <i class="fa fa-boxes text-amber-600"></i>
                </div>
                <div class="flex flex-col text-left">
                  <span class="font-bold whitespace-nowrap group-hover:text-amber-700">Écarts de Stock</span>
                  <span class="text-[10px] text-gray-400 leading-none">Rapprochement inventaire</span>
                </div>
              </a>
              <a routerLink="/cash-history" (click)="closeDropdown()"
                class="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 group transition-all duration-200">
                <div class="w-8 h-8 rounded-lg bg-blue-100 flex items-center justify-center mr-3 group-hover:bg-blue-200 transition-colors">
                  <i class="fa fa-history text-blue-600"></i>
                </div>
                <div class="flex flex-col text-left">
                  <span class="font-bold whitespace-nowrap group-hover:text-blue-700">Historique Caisse</span>
                  <span class="text-[10px] text-gray-400 leading-none">Journal des mouvements</span>
                </div>
              </a>
              <a routerLink="/reconciliation" (click)="closeDropdown()"
                class="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-emerald-50 group transition-all duration-200">
                <div class="w-8 h-8 rounded-lg bg-emerald-100 flex items-center justify-center mr-3 group-hover:bg-emerald-200 transition-colors">
                  <i class="fa fa-balance-scale text-emerald-600"></i>
                </div>
                <div class="flex flex-col text-left">
                  <span class="font-bold whitespace-nowrap group-hover:text-emerald-700">Réconciliation</span>
                  <span class="text-[10px] text-gray-400 leading-none">Dashboard de contrôle</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>


      <!-- Right Side - Search, Notifications, Profile -->
      <div class="flex items-center space-x-2 lg:space-x-4">


        <!-- Search Bar - Hidden on mobile -->
        <div class="hidden md:block relative search-container" #searchRef>
          <div class="relative">
            <i class="fa fa-search absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 transition-colors duration-200"
              [class.animate-spin]="isLoading" [class.text-blue-600]="isLoading" [class.text-gray-400]="!isLoading"></i>
            <input type="text" placeholder="Rechercher un client..." [(ngModel)]="searchTerm" (input)="onSearchChange()"
              (focus)="onInputFocus()"
              class="w-48 lg:w-64 pl-10 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200" />
          </div>
          <div *ngIf="showDropdown && filteredClients.length > 0"
            class="absolute top-full left-0 right-0 mt-2 bg-white rounded-xl shadow-xl border border-gray-100 py-2 z-[10000] max-h-64 overflow-y-auto">
            <a *ngFor="let client of filteredClients" [routerLink]="['/clientDetails']"
              [queryParams]="{ id: client.id }" (click)="clearSearch()"
              class="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors duration-200">
              <i class="fa fa-user w-4 h-4 mr-3 text-gray-400"></i>
              {{ client.firstName }} {{ client.lastName }}
            </a>
          </div>
        </div>

        <!-- Notifications -->
        <div class="relative notifications-container" #notificationRef>
          <button (click)="toggleNotifications()"
            class="relative p-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-xl transition-all duration-200">
            <i class="fa fa-bell w-5 h-5"></i>
            <span *ngIf="unreadCount > 0"
              class="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white text-xs rounded-full flex items-center justify-center font-medium animate-pulse">
              {{ unreadCount }}
            </span>
          </button>

          <!-- Responsive layout rules to mirror hamburger panel on < 1400px -->
          <style>
            @media (max-width: 1399px) {
              .notif-panel-1400 {
                position: fixed !important;
                top: 64px !important;
                /* h-16 navbar height */
                left: 0 !important;
                right: 0 !important;
                width: 100vw !important;
                max-width: 100vw !important;
                height: calc(100vh - 64px) !important;
                /* Full phone height below navbar */
                margin: 0 !important;
                border-radius: 0 !important;
                border-top: 1px solid #e5e7eb !important;
                /* match mobile menu border */
                display: flex !important;
                flex-direction: column !important;
                background: #ffffff !important;
              }

              .notif-panel-1400 .notif-scroll {
                flex: 1 1 auto !important;
                min-height: 0 !important;
                overflow-y: auto !important;
              }
            }
          </style>

          <div *ngIf="showNotifications"
            class="absolute top-full right-4 mt-2 w-80 sm:w-96 bg-white rounded-xl shadow-xl border border-gray-100 z-[10000] max-w-[90vw] sm:max-w-none notif-panel-1400">
            <div class="px-4 py-3 border-b border-gray-200">
              <div class="flex items-center justify-between">
                <h3 class="text-lg font-semibold text-gray-900">Notifications</h3>
                <button class="text-sm text-blue-600 hover:text-blue-700 font-medium" (click)="seeAllNotifications()">
                  Voir tout
                </button>
              </div>
              <div class="flex space-x-1 p-1 bg-gray-100 rounded-lg">
                <button (click)="setNotificationTab('all'); $event.stopPropagation()"
                  class="flex-1 py-2 px-3 text-sm font-medium rounded-md transition-all duration-200"
                  [class.bg-white]="notificationTab === 'all'" [class.text-blue-600]="notificationTab === 'all'"
                  [class.shadow-sm]="notificationTab === 'all'" [class.text-gray-600]="notificationTab !== 'all'"
                  [class.hover:text-gray-900]="notificationTab !== 'all'">
                  Toutes
                </button>
                <button (click)="setNotificationTab('unread'); $event.stopPropagation()"
                  class="flex-1 py-2 px-3 text-sm font-medium rounded-md transition-all duration-200"
                  [class.bg-white]="notificationTab === 'unread'" [class.text-blue-600]="notificationTab === 'unread'"
                  [class.shadow-sm]="notificationTab === 'unread'" [class.text-gray-600]="notificationTab !== 'unread'"
                  [class.hover:text-gray-900]="notificationTab !== 'unread'">
                  Non lues
                </button>
              </div>
            </div>
            <div class="max-h-80 overflow-y-auto notif-scroll">
              <div *ngIf="filteredNotifications().length === 0" class="p-6 text-center text-gray-500">
                <i class="fa fa-bell w-12 h-12 mx-auto mb-2 text-gray-300"></i>
                <p class="text-sm">Aucune notification</p>
              </div>
              <div *ngFor="let notification of filteredNotifications()"
                class="p-4 border-b border-gray-50 last:border-b-0 cursor-pointer hover:bg-gray-50 transition-colors duration-200"
                [class.bg-red-50]="!notification.read && (notification.type === 'CAMERA_VERIFICATION_URGENT' || notification.type === 'SECURITY_ALERT')"
                [class.bg-orange-50]="!notification.read && notification.type === 'RECONCILIATION_DANGER'"
                [class.bg-yellow-50]="!notification.read && notification.type === 'RECONCILIATION_WARNING'"
                [class.bg-blue-50]="!notification.read && (notification.type === 'RECONCILIATION_SUCCESS' || notification.type === 'INFO' || (!['CAMERA_VERIFICATION_URGENT', 'RECONCILIATION_DANGER', 'RECONCILIATION_WARNING', 'SECURITY_ALERT'].includes(notification.type)))"
                [class.border-l-4]="!notification.read"
                [class.border-l-red-500]="!notification.read && (notification.type === 'CAMERA_VERIFICATION_URGENT' || notification.type === 'SECURITY_ALERT')"
                [class.border-l-orange-500]="!notification.read && notification.type === 'RECONCILIATION_DANGER'"
                [class.border-l-yellow-500]="!notification.read && notification.type === 'RECONCILIATION_WARNING'"
                [class.border-l-blue-500]="!notification.read && (notification.type === 'RECONCILIATION_SUCCESS' || notification.type === 'INFO' || (!['CAMERA_VERIFICATION_URGENT', 'RECONCILIATION_DANGER', 'RECONCILIATION_WARNING', 'SECURITY_ALERT'].includes(notification.type)))"
                (click)="markAsRead(notification.id, $event)">
                <div class="flex items-start space-x-3">
                  <div class="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0"
                    [class.bg-red-100]="!notification.read && (notification.type === 'CAMERA_VERIFICATION_URGENT' || notification.type === 'SECURITY_ALERT')"
                    [class.text-red-600]="!notification.read && (notification.type === 'CAMERA_VERIFICATION_URGENT' || notification.type === 'SECURITY_ALERT')"
                    [class.bg-orange-100]="!notification.read && notification.type === 'RECONCILIATION_DANGER'"
                    [class.text-orange-600]="!notification.read && notification.type === 'RECONCILIATION_DANGER'"
                    [class.bg-yellow-100]="!notification.read && notification.type === 'RECONCILIATION_WARNING'"
                    [class.text-yellow-600]="!notification.read && notification.type === 'RECONCILIATION_WARNING'"
                    [class.bg-blue-100]="!notification.read && (notification.type === 'RECONCILIATION_SUCCESS' || notification.type === 'INFO' || (!['CAMERA_VERIFICATION_URGENT', 'RECONCILIATION_DANGER', 'RECONCILIATION_WARNING', 'SECURITY_ALERT'].includes(notification.type)))"
                    [class.text-blue-600]="!notification.read && (notification.type === 'RECONCILIATION_SUCCESS' || notification.type === 'INFO' || (!['CAMERA_VERIFICATION_URGENT', 'RECONCILIATION_DANGER', 'RECONCILIATION_WARNING', 'SECURITY_ALERT'].includes(notification.type)))"
                    [class.bg-gray-100]="notification.read" [class.text-gray-600]="notification.read">
                    <i class="fa w-4 h-4" [ngClass]="{
                      'fa-user-plus': notification.type === 'NEW_USER_REGISTRATION',
                      'fa-check-circle': notification.type === 'USER_APPROVED' || notification.type === 'CASH_DISCREPANCY_APPROVED_ADMIN' || notification.type === 'STOCK_DISCREPANCY_APPROVED_ADMIN' || notification.type === 'RECONCILIATION_SUCCESS',
                      'fa-times-circle': notification.type === 'USER_REJECTED',
                      'fa-envelope': notification.type === 'EMAIL_VERIFIED',
                      'fa-money-bill-wave': notification.type === 'CASH_DISCREPANCY_PENDING',
                      'fa-boxes': notification.type === 'STOCK_DISCREPANCY_PENDING',
                      'fa-check': notification.type === 'CASH_DISCREPANCY_APPROVED' || notification.type === 'STOCK_DISCREPANCY_APPROVED',
                      'fa-times': notification.type === 'CASH_DISCREPANCY_REJECTED' || notification.type === 'STOCK_DISCREPANCY_REJECTED',
                      'fa-shield-alt': notification.type === 'SECURITY_ALERT',
                      'fa-video': notification.type === 'CAMERA_VERIFICATION_URGENT',
                      'fa-exclamation-triangle': notification.type === 'RECONCILIATION_DANGER' || notification.type === 'RECONCILIATION_WARNING',
                      'fa-undo': notification.type === 'PENDING_AVOIR' || notification.type === 'APPROVED_AVOIR' || notification.type === 'AVOIR_READY',
                      'fa-info-circle': notification.type === 'INFO'
                    }"></i>
                  </div>
                  <div class="flex-1 min-w-0">
                    <p class="text-sm" [class.font-semibold]="!notification.read"
                      [class.text-gray-900]="!notification.read" [class.text-gray-700]="notification.read">
                      {{ notification.message }}
                    </p>
                    <p class="text-xs text-gray-500 mt-1">
                      {{ getRelativeTime(notification.timestamp) }}
                    </p>

                    <!-- Avoir Approval Button (Only shown when cash is ready) -->
                    <div *ngIf="notification.type === 'AVOIR_READY'" class="flex space-x-2 mt-3">
                      <button
                        class="px-3 py-1 bg-green-600 text-white text-xs font-bold rounded-lg hover:bg-green-700 transition-colors duration-200 shadow-sm"
                        [disabled]="isNotificationProcessing(notification.id)"
                        (click)="approveAvoirRequest(notification.id, $event)">
                        <i class="fa mr-1" [ngClass]="{
                          'fa-check': !approvingNotifications.has(notification.id),
                          'fa-spinner fa-spin': approvingNotifications.has(notification.id)
                        }"></i>
                        {{ approvingNotifications.has(notification.id) ? 'Approbation...' : 'Valider le Remboursement' }}
                      </button>
                    </div>

                    <!-- Pending Avoir Info (No button, just for information) -->
                    <div *ngIf="notification.type === 'PENDING_AVOIR'" class="mt-2">
                        <span class="text-[10px] bg-orange-100 text-orange-700 px-2 py-0.5 rounded-full font-bold uppercase">
                            En attente de Cash
                        </span>
                    </div>

                    <div *ngIf="notification.type === 'EMAIL_VERIFIED'" class="flex space-x-2 mt-3">
                      <button
                        class="px-3 py-1 bg-green-100 text-green-700 text-xs font-medium rounded-lg hover:bg-green-200 transition-colors duration-200"
                        [disabled]="isNotificationProcessing(notification.id)"
                        (click)="approveUser(notification.id, getSelectedRole(notification), $event)">
                        <i class="fa mr-1" [ngClass]="{
                          'fa-check': !approvingNotifications.has(notification.id),
                          'fa-spinner fa-spin': approvingNotifications.has(notification.id)
                        }"></i>
                        {{ approvingNotifications.has(notification.id) ? 'Approbation...' : 'Approuver' }}
                      </button>
                      <button
                        class="px-3 py-1 bg-red-100 text-red-700 text-xs font-medium rounded-lg hover:bg-red-200 transition-colors duration-200"
                        [disabled]="isNotificationProcessing(notification.id)"
                        (click)="rejectUser(notification.id, $event)">
                        <i class="fa mr-1" [ngClass]="{
                          'fa-times': !rejectingNotifications.has(notification.id),
                          'fa-spinner fa-spin': rejectingNotifications.has(notification.id)
                        }"></i>
                        {{ rejectingNotifications.has(notification.id) ? 'Rejet...' : 'Rejeter' }}
                      </button>
                    </div>

                    <!-- Boutons d'action pour les écarts de caisse -->
                    <div *ngIf="notification.type === 'CASH_DISCREPANCY_PENDING'" class="flex space-x-2 mt-3">
                      <button
                        class="px-3 py-1 bg-green-100 text-green-700 text-xs font-medium rounded-lg hover:bg-green-200 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                        [disabled]="isNotificationProcessing(notification.id)"
                        (click)="approveCashDiscrepancy(notification.id, $event); $event.stopPropagation()">
                        <i class="fa mr-1" [ngClass]="{
                          'fa-check': !approvingNotifications.has(notification.id),
                          'fa-spinner fa-spin animate-pulse': approvingNotifications.has(notification.id)
                        }"></i>
                        {{ approvingNotifications.has(notification.id) ? 'Approbation...' : 'Approuver' }}
                      </button>
                      <button
                        class="px-3 py-1 bg-red-100 text-red-700 text-xs font-medium rounded-lg hover:bg-red-200 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                        [disabled]="isNotificationProcessing(notification.id)"
                        (click)="rejectCashDiscrepancy(notification.id, $event); $event.stopPropagation()">
                        <i class="fa mr-1" [ngClass]="{
                          'fa-times': !rejectingNotifications.has(notification.id),
                          'fa-spinner fa-spin animate-pulse': rejectingNotifications.has(notification.id)
                        }"></i>
                        {{ rejectingNotifications.has(notification.id) ? 'Rejet...' : 'Rejeter' }}
                      </button>
                    </div>

                    <!-- Boutons d'action pour les écarts de stock -->
                    <div *ngIf="notification.type === 'STOCK_DISCREPANCY_PENDING'" class="flex space-x-2 mt-3">
                      <button
                        class="px-3 py-1 bg-green-100 text-green-700 text-xs font-medium rounded-lg hover:bg-green-200 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                        [disabled]="isNotificationProcessing(notification.id)"
                        (click)="approveStockDiscrepancy(notification.id, $event); $event.stopPropagation()">
                        <i class="fa mr-1" [ngClass]="{
                          'fa-check': !approvingNotifications.has(notification.id),
                          'fa-spinner fa-spin animate-pulse': approvingNotifications.has(notification.id)
                        }"></i>
                        {{ approvingNotifications.has(notification.id) ? 'Approbation...' : 'Approuver' }}
                      </button>
                      <button
                        class="px-3 py-1 bg-red-100 text-red-700 text-xs font-medium rounded-lg hover:bg-red-200 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                        [disabled]="isNotificationProcessing(notification.id)"
                        (click)="rejectStockDiscrepancy(notification.id, $event); $event.stopPropagation()">
                        <i class="fa mr-1" [ngClass]="{
                          'fa-times': !rejectingNotifications.has(notification.id),
                          'fa-spinner fa-spin animate-pulse': rejectingNotifications.has(notification.id)
                        }"></i>
                        {{ rejectingNotifications.has(notification.id) ? 'Rejet...' : 'Rejeter' }}
                      </button>
                    </div>


                  </div>
                  <div *ngIf="!notification.read" class="w-2 h-2 bg-blue-500 rounded-full flex-shrink-0 mt-2"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- User Profile (Icon only) -->
        <div class="relative" #profileRef>
          <button (click)="toggleDropdown('profile')"
            class="flex items-center p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200">
            <div
              class="w-8 h-8 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white text-sm font-semibold">
              {{ getUserInitials() }}
            </div>
            <i class="fa fa-chevron-down w-4 h-4 ml-2 text-gray-500 transition-transform duration-200"
              [class.rotate-180]="activeDropdown === 'profile'"></i>
          </button>

          <div *ngIf="activeDropdown === 'profile'"
            class="absolute top-full right-0 mt-2 w-64 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-[10000]">
            <!-- User Info Header -->
            <div class="px-4 py-3 border-b border-gray-100">
              <div class="flex items-center space-x-3">
                <div
                  class="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white font-semibold">
                  {{ getUserInitials() }}
                </div>
                <div>
                  <div class="text-sm font-semibold text-gray-900">
                    {{ getUserName() }}
                  </div>
                  <div class="text-xs text-gray-500">
                    {{ getUserEmail() }}
                  </div>
                </div>
              </div>
            </div>
            <!-- Menu Items -->
            <div class="py-1">
              <a *ngIf="isAdmin" routerLink="/admin-categories" (click)="closeDropdown()"
                class="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors duration-200">
                <i class="fa fa-tags w-4 h-4 mr-3 text-gray-500"></i>
                Gestion des catégories
              </a>
              <a *ngIf="isAdmin" routerLink="/admin-approvals" (click)="closeDropdown()"
                class="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors duration-200">
                <i class="fa fa-users-cog w-4 h-4 mr-3 text-gray-500"></i>
                Demandes d'approbation
              </a>
              <a *ngIf="isAdmin" routerLink="/financial-dashboard" (click)="closeDropdown()"
                class="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors duration-200">
                <i class="fa fa-chart-line w-4 h-4 mr-3 text-gray-500"></i>
                Tableau de Bord Financier
              </a>
              <a *ngIf="isAdmin" routerLink="/discrepancy-dashboard" (click)="closeDropdown()"
                class="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors duration-200">
                <i class="fa fa-exclamation-triangle w-4 h-4 mr-3 text-gray-500"></i>
                Tableau de Bord des Écarts
              </a>
              <a href="#" (click)="closeDropdown()"
                class="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors duration-200">
                <i class="fa fa-cog w-4 h-4 mr-3 text-gray-500"></i>
                Paramètres
              </a>
              <button (click)="connectCashDrawer(); closeDropdown()"
                class="w-full flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors duration-200">
                <i class="fa fa-cash-register w-4 h-4 mr-3 text-gray-500"></i>
                Connecter Caisse
              </button>
              <button (click)="connectScanner(); closeDropdown()"
                class="w-full flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition-colors duration-200">
                <i class="fa fa-barcode w-4 h-4 mr-3"
                   [class.text-green-500]="barcodeScannerService.hidConnected"
                   [class.text-gray-500]="!barcodeScannerService.hidConnected"></i>
                {{ barcodeScannerService.hidConnected ? 'Scanner connecté ✓' : 'Connecter Scanner' }}
              </button>
              <div class="border-t border-gray-100 my-1"></div>
              <button (click)="logout(); closeDropdown()"
                class="w-full flex items-center px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition-colors duration-200">
                <i class="fa fa-sign-out-alt w-4 h-4 mr-3"></i>
                Déconnexion
              </button>

            </div>
          </div>
        </div>

        <!-- Mobile Menu Button avec breakpoint personnalisé -->
        <style>
          @media (min-width: 1400px) {
            .hamburger-1400 {
              display: none !important;
            }
          }
        </style>
        <button (click)="toggleMobileMenu()"
          class="hamburger-1400 p-2 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-xl transition-all duration-200">
          <i class="fa" [class.fa-bars]="!isMobileMenuOpen" [class.fa-times]="isMobileMenuOpen"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- Mobile Menu -->
  <style>
    @media (min-width: 1400px) {
      .mobile-menu-1400 {
        display: none !important;
      }
    }
  </style>
  <div *ngIf="isMobileMenuOpen" class="mobile-menu-1400 border-t border-gray-100 bg-white relative">
    <!-- Mobile Search avec dropdown correctement positionné -->
    <div class="px-4 pt-4 pb-2 relative">
      <div class="relative">
        <i class="fa fa-search absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400"
          [class.animate-spin]="isLoading" [class.text-blue-600]="isLoading" [class.text-gray-400]="!isLoading"></i>
        <input type="text" placeholder="Rechercher un client..." [(ngModel)]="searchTerm" (input)="onSearchChange()"
          (focus)="onMobileSearchFocus($event)" (click)="$event.stopPropagation()"
          class="w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
      </div>

      <!-- Mobile Search Dropdown -->
      <div *ngIf="showMobileDropdown && filteredClients.length > 0"
        class="absolute left-0 right-0 mt-2 bg-white rounded-xl shadow-xl border border-gray-100 py-2 z-[10000] max-h-64 overflow-y-auto">
        <a *ngFor="let client of filteredClients" [routerLink]="['/clientDetails']" [queryParams]="{ id: client.id }"
          (click)="clearSearch(); $event.stopPropagation()"
          class="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors duration-200">
          <i class="fa fa-user w-4 h-4 mr-3 text-gray-400"></i>
          {{ client.firstName }} {{ client.lastName }}
        </a>
      </div>
    </div>

    <!-- Mobile Navigation -->
    <div class="px-4 pb-4 space-y-1 max-h-[calc(100vh-200px)] overflow-y-auto">
      <a routerLink="/home" routerLinkActive="text-blue-600 bg-blue-50"
        class="flex items-center px-4 py-3 text-sm font-medium text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-200">
        <i class="fa fa-home w-5 h-5 mr-3"></i>
        Accueil
      </a>

      <!-- Mobile Products -->
      <div class="space-y-1">
        <button (click)="toggleMobileDropdown('products')"
          class="w-full flex items-center justify-between px-4 py-3 text-sm font-medium text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-200">
          <div class="flex items-center">
            <i class="fa fa-box w-5 h-5 mr-3"></i>
            Produits
          </div>
          <i class="fa fa-chevron-down w-4 h-4 transition-transform duration-200"
            [class.rotate-180]="activeMobileDropdown === 'products'"></i>
        </button>
        <div *ngIf="activeMobileDropdown === 'products'" class="ml-8 space-y-1">
          <a routerLink="/addProduct" (click)="closeMobileMenu()"
            class="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-emerald-50 rounded-xl group transition-all duration-200">
            <div class="w-10 h-10 rounded-xl bg-emerald-100 flex items-center justify-center mr-3 group-hover:bg-emerald-200 transition-colors">
              <i class="fa fa-plus text-emerald-600"></i>
            </div>
            <div class="flex flex-col">
              <span class="font-bold whitespace-nowrap group-hover:text-emerald-700">Ajouter un produit</span>
              <span class="text-[10px] text-gray-400 leading-none">Nouvel article stock</span>
            </div>
          </a>
          <a routerLink="/productList" (click)="closeMobileMenu()"
            class="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-indigo-50 rounded-xl group transition-all duration-200">
            <div class="w-10 h-10 rounded-xl bg-indigo-100 flex items-center justify-center mr-3 group-hover:bg-indigo-200 transition-colors">
              <i class="fa fa-list text-indigo-600"></i>
            </div>
            <div class="flex flex-col">
              <span class="font-bold whitespace-nowrap group-hover:text-indigo-700">Liste des produits</span>
              <span class="text-[10px] text-gray-400 leading-none">Inventaire complet</span>
            </div>
          </a>
        </div>
      </div>

      <!-- Mobile Orders -->
      <div class="space-y-1">
        <button (click)="toggleMobileDropdown('orders')"
          class="w-full flex items-center justify-between px-4 py-3 text-sm font-medium text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-200">
          <div class="flex items-center">
            <i class="fa fa-shopping-cart w-5 h-5 mr-3"></i>
            Commandes
          </div>
          <i class="fa fa-chevron-down w-4 h-4 transition-transform duration-200"
            [class.rotate-180]="activeMobileDropdown === 'orders'"></i>
        </button>
        <div *ngIf="activeMobileDropdown === 'orders'" class="ml-8 space-y-1">
          <button (click)="openClientFormDialog('addOrder'); closeMobileMenu()"
            class="w-full flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 rounded-xl group transition-all duration-200 text-left">
            <div class="w-10 h-10 rounded-xl bg-blue-100 flex items-center justify-center mr-3 group-hover:bg-blue-200 transition-colors">
              <i class="fa fa-file-invoice text-blue-600"></i>
            </div>
            <div class="flex flex-col">
              <span class="font-bold whitespace-nowrap group-hover:text-blue-700">Créer une commande</span>
              <span class="text-[10px] text-gray-400 leading-none">Nouvelle facture client</span>
            </div>
          </button>
          <button (click)="openSmartRefundFinder(); closeMobileMenu()"
            class="w-full flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-rose-50 rounded-xl group transition-all duration-200 text-left">
            <div class="w-10 h-10 rounded-xl bg-rose-100 flex items-center justify-center mr-3 group-hover:bg-rose-200 transition-colors">
              <i class="fa fa-reply text-rose-600"></i>
            </div>
            <div class="flex flex-col">
              <span class="font-bold whitespace-nowrap group-hover:text-rose-700">Créer un retour</span>
              <span class="text-[10px] text-gray-400 leading-none">Remboursement partiel/total</span>
            </div>
          </button>
          <a routerLink="/orderList" (click)="closeMobileMenu()"
            class="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-purple-50 rounded-xl group transition-all duration-200">
            <div class="w-10 h-10 rounded-xl bg-purple-100 flex items-center justify-center mr-3 group-hover:bg-purple-200 transition-colors">
              <i class="fa fa-list-alt text-purple-600"></i>
            </div>
            <div class="flex flex-col">
              <span class="font-bold whitespace-nowrap group-hover:text-purple-700">Liste des commandes</span>
              <span class="text-[10px] text-gray-400 leading-none">Historique des ventes</span>
            </div>
          </a>
          <a routerLink="/avoir-list" (click)="closeMobileMenu()"
            class="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-orange-50 rounded-xl group transition-all duration-200">
            <div class="w-10 h-10 rounded-xl bg-orange-100 flex items-center justify-center mr-3 group-hover:bg-orange-200 transition-colors">
              <i class="fa fa-undo text-orange-600"></i>
            </div>
            <div class="flex flex-col">
              <span class="font-bold whitespace-nowrap group-hover:text-orange-700">Liste des avoirs</span>
              <span class="text-[10px] text-gray-400 leading-none">Gérer les retours clients</span>
            </div>
          </a>
        </div>
      </div>

      <!-- Mobile Loans -->
      <div class="space-y-1">
        <button (click)="toggleMobileDropdown('loans')"
          class="w-full flex items-center justify-between px-4 py-3 text-sm font-medium text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-200">
          <div class="flex items-center">
            <i class="fa fa-credit-card w-5 h-5 mr-3"></i>
            Prêts
          </div>
          <i class="fa fa-chevron-down w-4 h-4 transition-transform duration-200"
            [class.rotate-180]="activeMobileDropdown === 'loans'"></i>
        </button>
        <div *ngIf="activeMobileDropdown === 'loans'" class="ml-8 space-y-1">
          <button (click)="openClientFormDialog('addCashLoan'); closeMobileMenu()"
            class="w-full flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-cyan-50 rounded-xl group transition-all duration-200 text-left">
            <div class="w-10 h-10 rounded-xl bg-cyan-100 flex items-center justify-center mr-3 group-hover:bg-cyan-200 transition-colors">
              <i class="fa fa-plus text-cyan-600"></i>
            </div>
            <div class="flex flex-col">
              <span class="font-bold whitespace-nowrap group-hover:text-cyan-700">Ajouter un prêt</span>
              <span class="text-[10px] text-gray-400 leading-none">Nouveau crédit client</span>
            </div>
          </button>
          <a routerLink="/loanList" (click)="closeMobileMenu()"
            class="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-teal-50 rounded-xl group transition-all duration-200">
            <div class="w-10 h-10 rounded-xl bg-teal-100 flex items-center justify-center mr-3 group-hover:bg-teal-200 transition-colors">
              <i class="fa fa-list text-teal-600"></i>
            </div>
            <div class="flex flex-col">
              <span class="font-bold whitespace-nowrap group-hover:text-teal-700">Liste des prêts</span>
              <span class="text-[10px] text-gray-400 leading-none">Suivi des paiements</span>
            </div>
          </a>
        </div>
      </div>

      <!-- Mobile Clients -->
      <div class="space-y-1">
        <button (click)="toggleMobileDropdown('clients')"
          class="w-full flex items-center justify-between px-4 py-3 text-sm font-medium text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-200">
          <div class="flex items-center">
            <i class="fa fa-users w-5 h-5 mr-3"></i>
            Clients
          </div>
          <i class="fa fa-chevron-down w-4 h-4 transition-transform duration-200"
            [class.rotate-180]="activeMobileDropdown === 'clients'"></i>
        </button>
        <div *ngIf="activeMobileDropdown === 'clients'" class="ml-8 space-y-1">
          <a routerLink="/addClient" (click)="closeMobileMenu()"
            class="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-amber-50 rounded-xl group transition-all duration-200">
            <div class="w-10 h-10 rounded-xl bg-amber-100 flex items-center justify-center mr-3 group-hover:bg-amber-200 transition-colors">
              <i class="fa fa-user-plus text-amber-600"></i>
            </div>
            <div class="flex flex-col">
              <span class="font-bold whitespace-nowrap group-hover:text-amber-700">Ajouter un client</span>
              <span class="text-[10px] text-gray-400 leading-none">Nouveau profil client</span>
            </div>
          </a>
        </div>
      </div>

      <!-- Mobile Discrepancies -->
      <div class="space-y-1">
        <button (click)="toggleMobileDropdown('discrepancies')"
          class="w-full flex items-center justify-between px-4 py-3 text-sm font-medium text-gray-700 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-200">
          <div class="flex items-center">
            <i class="fa fa-exclamation-triangle w-5 h-5 mr-3"></i>
            Écarts
          </div>
          <i class="fa fa-chevron-down w-4 h-4 transition-transform duration-200"
            [class.rotate-180]="activeMobileDropdown === 'discrepancies'"></i>
        </button>
        <div *ngIf="activeMobileDropdown === 'discrepancies'" class="ml-8 space-y-1">
          <a routerLink="/cash-discrepancies" (click)="closeMobileMenu()"
            class="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-red-50 rounded-xl group transition-all duration-200">
            <div class="w-10 h-10 rounded-xl bg-red-100 flex items-center justify-center mr-3 group-hover:bg-red-200 transition-colors">
              <i class="fa fa-money-bill text-red-600"></i>
            </div>
            <div class="flex flex-col">
              <span class="font-bold whitespace-nowrap group-hover:text-red-700">Écarts de Caisse</span>
              <span class="text-[10px] text-gray-400 leading-none">Rapprochement financier</span>
            </div>
          </a>
          <a routerLink="/stock-discrepancies" (click)="closeMobileMenu()"
            class="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-amber-50 rounded-xl group transition-all duration-200">
            <div class="w-10 h-10 rounded-xl bg-amber-100 flex items-center justify-center mr-3 group-hover:bg-amber-200 transition-colors">
              <i class="fa fa-boxes text-amber-600"></i>
            </div>
            <div class="flex flex-col">
              <span class="font-bold whitespace-nowrap group-hover:text-amber-700">Écarts de Stock</span>
              <span class="text-[10px] text-gray-400 leading-none">Rapprochement inventaire</span>
            </div>
          </a>
          <a routerLink="/cash-history" (click)="closeMobileMenu()"
            class="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-blue-50 rounded-xl group transition-all duration-200">
            <div class="w-10 h-10 rounded-xl bg-blue-100 flex items-center justify-center mr-3 group-hover:bg-blue-200 transition-colors">
              <i class="fa fa-history text-blue-600"></i>
            </div>
            <div class="flex flex-col">
              <span class="font-bold whitespace-nowrap group-hover:text-blue-700">Historique Caisse</span>
              <span class="text-[10px] text-gray-400 leading-none">Mouvements récents</span>
            </div>
          </a>
          <a routerLink="/reconciliation" (click)="closeMobileMenu()"
            class="flex items-center px-4 py-3 text-sm text-gray-700 hover:bg-emerald-50 rounded-xl group transition-all duration-200">
            <div class="w-10 h-10 rounded-xl bg-emerald-100 flex items-center justify-center mr-3 group-hover:bg-emerald-200 transition-colors">
              <i class="fa fa-balance-scale text-emerald-600"></i>
            </div>
            <div class="flex flex-col text-left">
              <span class="font-bold whitespace-nowrap group-hover:text-emerald-700">Réconciliation</span>
              <span class="text-[10px] text-gray-400 leading-none">Dashboard de contrôle</span>
            </div>
          </a>
        </div>
      </div>

      <!-- Mobile User Profile -->
      <div class="px-4 py-4 border-t border-gray-100 mt-4">
        <div class="flex items-center space-x-3 mb-4">
          <div
            class="w-10 h-10 bg-gradient-to-br from-blue-600 to-purple-600 rounded-full flex items-center justify-center">
            <span class="text-white text-sm font-medium">{{ getUserInitials() }}</span>
          </div>
          <div class="flex-1">
            <p class="text-sm font-medium text-gray-900">{{ getUserName() }}</p>
            <p class="text-xs text-gray-500">{{ getUserEmail() }}</p>
          </div>
        </div>
        <div class="space-y-1">
          <a *ngIf="isAdmin" routerLink="/admin-categories" (click)="closeMobileMenu()"
            class="flex items-center px-3 py-3 text-sm text-gray-700 hover:bg-slate-50 rounded-xl group transition-all duration-200">
            <div class="w-8 h-8 rounded-lg bg-slate-100 flex items-center justify-center mr-3 group-hover:bg-slate-200 transition-colors">
              <i class="fa fa-tags text-slate-600"></i>
            </div>
            <span class="font-bold whitespace-nowrap group-hover:text-slate-900">Gestion des catégories</span>
          </a>
          <a *ngIf="isAdmin" routerLink="/financial-dashboard" (click)="closeMobileMenu()"
            class="flex items-center px-3 py-3 text-sm text-gray-700 hover:bg-indigo-50 rounded-xl group transition-all duration-200">
            <div class="w-8 h-8 rounded-lg bg-indigo-100 flex items-center justify-center mr-3 group-hover:bg-indigo-200 transition-colors">
              <i class="fa fa-chart-line text-indigo-600"></i>
            </div>
            <span class="font-bold whitespace-nowrap group-hover:text-indigo-900">Tableau de Bord Financier</span>
          </a>
          <a *ngIf="isAdmin" routerLink="/discrepancy-dashboard" (click)="closeMobileMenu()"
            class="flex items-center px-3 py-3 text-sm text-gray-700 hover:bg-rose-50 rounded-xl group transition-all duration-200">
            <div class="w-8 h-8 rounded-lg bg-rose-100 flex items-center justify-center mr-3 group-hover:bg-rose-200 transition-colors">
              <i class="fa fa-exclamation-triangle text-rose-600"></i>
            </div>
            <span class="font-bold whitespace-nowrap group-hover:text-rose-900">Tableau de Bord des Écarts</span>
          </a>
          <button (click)="connectCashDrawer(); closeMobileMenu()"
            class="w-full flex items-center px-3 py-3 text-sm text-gray-700 hover:bg-emerald-50 rounded-xl group transition-all duration-200">
            <div class="w-8 h-8 rounded-lg bg-emerald-100 flex items-center justify-center mr-3 group-hover:bg-emerald-200 transition-colors">
              <i class="fa fa-cash-register text-emerald-600"></i>
            </div>
            <span class="font-bold whitespace-nowrap group-hover:text-emerald-900">Connecter Caisse</span>
          </button>
          <button (click)="connectScanner(); closeMobileMenu()"
            class="w-full flex items-center px-3 py-3 text-sm text-gray-700 hover:bg-indigo-50 rounded-xl group transition-all duration-200">
            <div class="w-8 h-8 rounded-lg flex items-center justify-center mr-3 transition-colors"
                 [class.bg-green-100]="barcodeScannerService.hidConnected"
                 [class.bg-indigo-100]="!barcodeScannerService.hidConnected">
              <i class="fa fa-barcode"
                 [class.text-green-600]="barcodeScannerService.hidConnected"
                 [class.text-indigo-600]="!barcodeScannerService.hidConnected"></i>
            </div>
            <span class="font-bold whitespace-nowrap"
                  [class.text-green-700]="barcodeScannerService.hidConnected"
                  [class.group-hover:text-indigo-900]="!barcodeScannerService.hidConnected">
              {{ barcodeScannerService.hidConnected ? 'Scanner connecté ✓' : 'Connecter Scanner' }}
            </span>
          </button>
          <div class="border-t border-gray-100 my-2"></div>
          <button (click)="logout(); closeMobileMenu()"
            class="w-full flex items-center px-3 py-3 text-sm text-red-600 hover:bg-red-50 rounded-xl group transition-all duration-200">
            <div class="w-8 h-8 rounded-lg bg-red-100 flex items-center justify-center mr-3 group-hover:bg-red-200 transition-colors">
              <i class="fa fa-sign-out-alt text-red-600"></i>
            </div>
            <span class="font-bold whitespace-nowrap group-hover:text-red-700">Déconnexion</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</nav>